import React, { useEffect, useState, Fragment } from 'react';
import styles from './index.module.scss';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import http from '@/assets/api/http';
import model from '@/reducers/system/versions/model';
import { Card, Typography, message, Input, Button, Space } from 'antd';
import { FormOutlined } from '@ant-design/icons';
import CusotmUpload, { generateFileList } from '@/components/NewUpload';
import { showConfirm } from '@/components/xqxc_ui.js';

const { Text } = Typography;
const { TextArea } = Input;

const About = ({
    getAboutUsInfo,
    aboutUsInfo = []
}) => {

    const [isClientEdit, setIsClientEdit] = useState(false);
    const [isRiderEdit, setIsRiderEdit] = useState(false);
    const [clientUrl, setClientUrl] = useState('');
    const [clientRemark, setClientRemark] = useState('');
    const [riderUrl, setRiderUrl] = useState('');
    const [riderRemark, setRiderRemark] = useState('');

    useEffect(() => {
        getAboutUsInfo({ paramType: 'APP' });
    }, []);

    useEffect(() => {
        setClientUrl(aboutUsInfo[2] ? aboutUsInfo[2].paramValue : '');
        setClientRemark(aboutUsInfo[0] ? aboutUsInfo[0].paramValue : '');
        setRiderUrl(aboutUsInfo[3] ? aboutUsInfo[3].paramValue : '');
        setRiderRemark(aboutUsInfo[1] ? aboutUsInfo[1].paramValue : '');
    }, [aboutUsInfo]);



    const extraNode = (type) => {
        return <div
            className={styles.edit}
            onClick={() => type === 'CUSTOMER_ABOUT_US' ? setIsClientEdit(true) : setIsRiderEdit(true)}
        >
            <FormOutlined />
            <Text>编辑</Text>
        </div>;
    };

    const onSubmit = (type) => {
        let list = [];
        if (type === 'client') {
            if (!clientRemark) {
                message.warning('请输入客户端介绍');
                return;
            }
            if (!clientUrl) {
                message.warning('请输入客户端图片');
                return;
            }
            list = [
                { paramCode: 'CUSTOMER_ABOUT_US', paramValue: clientRemark },
                { paramCode: 'CUSTOMER_ICON_URL', paramValue: clientUrl }
            ];
        } else if (type === 'rider') {
            if (!riderRemark) {
                message.warning('请输入骑士端介绍');
                return;
            }
            if (!riderUrl) {
                message.warning('请输入骑士端图片');
                return;
            }
            list = [
                { paramCode: 'RIDER_ABOUT_US', paramValue: riderRemark },
                { paramCode: 'RIDER_ICON_URL', paramValue: riderUrl }
            ];
        }
        http('/?cmd=com.xqxc.api.pig.mis.biz.platform.AdminParamMisService.batchSaveParam', { list }, 'POST')
            .then(() => {
                message.success('编辑操作成功');
                setIsClientEdit(false);
                setIsRiderEdit(false);
                getAboutUsInfo({ paramType: 'APP' });
            })
            .catch(error => {
                message.error(error.message);
            });
    };

    //取消操作
    const onCancel = (type) => {
        showConfirm('有内容没有保存，确定退出编辑吗？', '退出编辑后，更新的内容不会自动保存', () => {
            switch (type) {
                case 'CUSTOMER_ABOUT_US':
                    setIsClientEdit(false);
                    getAboutUsInfo({ paramType: 'APP' });
                    break;
                case 'RIDER_ABOUT_US':
                    setIsRiderEdit(false);
                    getAboutUsInfo({ paramType: 'APP' });
                    break;
            }
        });
    };

    return <div className={styles.container}>
        <Card
            title='客户端'
            extra={!isClientEdit ? extraNode('CUSTOMER_ABOUT_US') : ''}
            className={styles.cardItem}>
            {
                isClientEdit ?
                    <Fragment>
                        <Space>
                            <div>
                                <Text type='danger'>*</Text>
                                <Text>图片：</Text>
                            </div>
                            <CusotmUpload
                                accept='.png, .jpg, .jpeg,.gif'
                                listType="picture-card"
                                wallMode='single'
                                fileList={aboutUsInfo[3] ? generateFileList(clientUrl) : generateFileList('')}
                                qiniuUploadProps={{ uploadType: 'image' }}
                                removeError
                                beforeUpload={file => {
                                    const isType = ['image/png', 'image/jpeg', 'image/jpg', 'image/gif'];
                                    const isLt3M = file.size / 1024 / 1024 > 3;
                                    if (!isType.includes(file.type)) {
                                        message.warn('只能上传png,jpg, gif格式的图片!');
                                        file.status = 'error';
                                        return false;
                                    } else if (isLt3M) {
                                        message.warn('图片必须小于 3MB!');
                                        file.status = 'error';
                                        return false;
                                    }
                                }}
                                onFileListChange={file => {
                                    let url = file.fileList[0] ? file.fileList[0].url : '';
                                    setClientUrl(url);
                                }}
                            >
                                <div style={{ color: '#999999', fontSize: '12px' }}>添加上传图片</div>
                            </CusotmUpload>
                            <div>
                                <Text type='danger'>*</Text>
                                <Text>介绍：</Text>
                            </div>
                            <TextArea
                                placeholder='请输入介绍内容'
                                rows={4}
                                style={{ width: '600px' }}
                                value={clientRemark}
                                onChange={e => setClientRemark(e.target.value)}
                            />
                        </Space>
                        <div>
                            <Button type='primary' onClick={() => onSubmit('client')}>保存</Button>
                            <Button onClick={() => onCancel('CUSTOMER_ABOUT_US')} style={{ marginLeft: '20px' }}>取消</Button>
                        </div>
                    </Fragment> :
                    <div className={styles.innderBox}>
                        <div className={styles.imgBox}>
                            <img width='150px' height='150px' src={clientUrl} />
                        </div>
                        <div className={styles.textBox}>{clientRemark}</div>
                    </div>
            }
        </Card>
        <Card
            title='骑士端'
            extra={!isRiderEdit ? extraNode('RIDER_ABOUT_US') : ''}
            className={styles.cardItem}>
            {
                isRiderEdit ?
                    <Fragment>
                        <Space>
                            <div>
                                <Text type='danger'>*</Text>
                                <Text>图片：</Text>
                            </div>
                            <CusotmUpload
                                accept='.png, .jpg, .jpeg,.gif'
                                listType="picture-card"
                                wallMode='single'
                                fileList={aboutUsInfo[3] ? generateFileList(riderUrl) : generateFileList('')}
                                qiniuUploadProps={{ uploadType: 'image' }}
                                removeError
                                beforeUpload={file => {
                                    const isType = ['image/png', 'image/jpeg', 'image/jpg', 'image/gif'];
                                    const isLt3M = file.size / 1024 / 1024 > 3;
                                    if (!isType.includes(file.type)) {
                                        message.warn('只能上传png,jpg, gif格式的图片!');
                                        file.status = 'error';
                                        return false;
                                    } else if (isLt3M) {
                                        message.warn('图片必须小于 3MB!');
                                        file.status = 'error';
                                        return false;
                                    }
                                }}
                                onFileListChange={file => {
                                    let url = file.fileList[0] ? file.fileList[0].url : '';
                                    setRiderUrl(url);
                                }}
                            >
                                <div style={{ color: '#999999', fontSize: '12px' }}>添加上传图片</div>
                            </CusotmUpload>
                            <div>
                                <Text type='danger'>*</Text>
                                <Text>介绍：</Text>
                            </div>
                            <TextArea
                                placeholder='请输入介绍内容'
                                rows={4}
                                style={{ width: '600px' }}
                                value={riderRemark}
                                onChange={e => setRiderRemark(e.target.value)}
                            />
                        </Space>
                        <div>
                            <Button type='primary' onClick={() => onSubmit('rider')}>保存</Button>
                            <Button onClick={() => onCancel('RIDER_ABOUT_US')} style={{ marginLeft: '20px' }}>取消</Button>
                        </div>
                    </Fragment> :
                    <div className={styles.innderBox}>
                        <div className={styles.imgBox}>
                            <img width='150px' height='150px' src={riderUrl} />
                        </div>
                        <div className={styles.textBox}>{riderRemark}</div>
                    </div>
            }
        </Card>
    </div>;
};
About.propTypes = {
    getAboutUsInfo: PropTypes.func,
    aboutUsInfo: PropTypes.array
};
export default connect(state => ({
    aboutUsInfo: state.versions.aboutUsInfo,
}), {
    ...model.actions
})(About);